import styled, { css } from 'styled-components'
import { theme } from '@provi/provi-components'
import { Body2, Caption } from '~/styles/global'

export const CourseFinancingPartnerConditionWrapper = styled.button`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;

  width: 100%;
  height: 100%;
  max-height: 44px;

  font-family: 'Montserrat', sans-serif;
  cursor: pointer;

  @media (prefers-reduced-motion) {
    transition: all 0s linear;
  }
`

export const PartnerConditionInstallmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;

  width: 100%;
  height: 100%;
  padding: 4px 0 0;
`

export const PartnerConditionLabel = styled(Body2)`
  display: flex;
  align-items: center;

  height: 100%;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  font-weight: 600;

  label {
    input {
      display: none;
    }
  }

  sup {
    top: -0.3rem;
  }
`

export const PartnerConditionPrice = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.0075em;

  display: flex;
  align-items: center;

  sup {
    top: -0.3rem;
  }
`

export const PartnerConditionInconstant = styled(Caption)``

const defaultPartnerConditionStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding-left: 48px;
  padding-right: 16px;
`

export const PartnerConditionInterest = styled(Caption)`
  ${defaultPartnerConditionStyle}

  margin-bottom: 5px;
`

export const PartnerConditionUpfrontPayment = styled(Caption)`
  ${defaultPartnerConditionStyle}

  margin-bottom: 6px;
  color: ${theme.colors.bluePrimary};
`

export const PartnerConditionTotalPrice = styled(Caption)`
  ${defaultPartnerConditionStyle}

  background: ${theme.colors.bluePrimary};
  color: #ffffff;
  padding-top: 6px;
  padding-bottom: 6px;
`
